import {Collection} from './Collection';
import {SearchSuggestionModel} from '../models/SearchSuggestionModel';

export class SearchSuggestionCollection extends Collection {
  get model() {
    return SearchSuggestionModel;
  }
}
